import {
    compareDates,
    isSameDay,
} from 'utils/datetime';

export const isNeedToAddFlatLine = (chartStartDate: Date, date: Date): boolean => compareDates(date, chartStartDate);

export const adaptStartDate = (chartStartDate: Date, date: Date): Date => {
    // if data exist in date exists
    if (isSameDay(chartStartDate, date)) return chartStartDate;
    // if no data and it's XXXX-01-01, return XXXX-01-02 because of Jan 1st is day-off
    // if (isSameDay(chartStartDate, getFirstDayOfYear())) return getSecondDayOfYear();

    return chartStartDate;
};
